export default {
  methods: {
    isLostClient(client) {
      if (!client.active_until) {
        return false;
      }

      const lostThreshold = 60 * 24 * 60 * 60; // 60 days
      const today         = this.$dayjs().startOf('day').unix();
      const lostFor       = today - client.active_until;

      return lostFor >= lostThreshold;
    },
  }
};
